import { useRef, useCallback } from "react"

const useRefWithCallback = (onMount, onUnmount) => {
  const nodeRef = useRef(null)

  const setRef = useCallback(
    (node) => {
      if (nodeRef.current && onUnmount) {
        onUnmount(nodeRef.current)
      }

      nodeRef.current = node

      if (nodeRef.current) {
        onMount(nodeRef.current)
      }
    },
    [onMount, onUnmount]
  )

  return setRef
}

export default useRefWithCallback
